export default {
  'get-list': {
    method: 'post',
    url: '/client/order/list'
  },
  add: {
    method: 'post',
    url: '/client/order'
  },
  delete: {
    method: 'delete',
    url: '/client/order'
  },
  update: {
    method: 'put',
    url: '/client/order/ID'
  },
  updatePatch: {
    method: 'patch',
    url: '/client/order/ID'
  },
  detail: {
    method: 'get',
    url: '/client/order/ID'
  },
  changeStatus: {
    method: 'put',
    url: '/client/order/status'
  },
  select: {
    method: 'get',
    url: '/client/order/find?key=KEY'
  },
  'calculate-shipping-plan': {
    method: 'post',
    url: '/client/order/calculate-shipping-plan'
  },
  'calculate-shipping-plan-manual': {
    method: 'post',
    url: '/client/order/calculate-shipping-plan-manual'
  },
  'create-teamplate-shipping-plan': {
    method: 'post',
    url: '/client/order/create-teamplate-shipping-plan'
  },
  'quote-by-customer-request': {
    method: 'post',
    url: '/client/order/quote-by-customer-request'
  },
  'add-by-request': {
    method: 'post',
    url: '/client/order/add-by-request'
  },
  'add-document': {
    method: 'POST',
    url: '/client/order/document/upload'
  },
  'delete-document': {
    url: '/client/order/document/delete',
    method: 'DELETE'
  },
  'edit-document': {
    url: '/client/order/document/file/ID',
    method: 'PUT'
  },
  archive: {
    method: 'delete',
    url: '/client/order/archive'
  },
  restore: {
    method: 'put',
    url: '/client/order/restore'
  },
  searchQuote: {
    method: 'get',
    url: '/client/order/search-quote/ID'
  },
  addQuoteToOrder: {
    method: 'post',
    url: '/client/order/add-quote/ID'
  },
  editQuoteToOrder: {
    method: 'put',
    url: '/client/order/edit-quote/ID'
  },
  cancel: {
    method: 'put',
    url: '/client/order/ID/cancel'
  },
  addContainerNumbers: {
    method: 'post',
    url: '/client/order/ID/container-number'
  },
  getContainerNumbers: {
    method: 'get',
    url: '/client/order/ID/container-number'
  },
  addContainerNumber: {
    method: 'post',
    url: '/client/order/ID/container-one-number'
  }
}
